/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, StringScalar, render, Mutation, SelectionSet, Field, IdScalar } from "graphql-jsx";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid: string;
  type: string;
  languageCode: string;
  value: string;
}>;

export const UpdateRoleTitle = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar />} value={option.uuid} />;
  const $type = <Variable name="type_role_title" scalar={<StringScalar />} value={option.type} />;
  const $value = <Variable name="value" scalar={<StringScalar />} value={option.value} />;
  const $languageCode = <Variable name="language_code" scalar={<IdScalar />} value={option.languageCode} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_ROLE_TITLE">
      <SelectionSet
        name="updateRole_title"
        alias="updateRoleTitle"
        argument={{
          where: {
            id: $uuid
          },
          data: {
            type_role_title: $type,
            language: { connect: { language_code: $languageCode } },
            value: $value
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );

  type Data = Readonly<{
    updateRoleTitle: {
      id: string;
    };
  }>;

  return await clients.role.request<Data>(query, variables);
};
